import { render, staticRenderFns } from "./waitting.vue?vue&type=template&id=a58d10b8&scoped=true&"
import script from "./waitting.vue?vue&type=script&lang=js&"
export * from "./waitting.vue?vue&type=script&lang=js&"
import style0 from "./waitting.vue?vue&type=style&index=0&id=a58d10b8&scoped=true&lang=css&"
import style1 from "./waitting.vue?vue&type=style&index=1&id=a58d10b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58d10b8",
  null
  
)

export default component.exports